<script setup lang="ts">
defineOptions({ inheritAttrs: false });

withDefaults(defineProps<{
    inbound?: boolean;
    error?: boolean;
}>(), {
    inbound: true,
    error: false
});
</script>

<template>
    <div
        class="flex"
        :class="inbound ? 'message-container-inbound' : 'message-container-outbound'"
    >
        <div
            v-bind="$attrs"
            class="rounded-lg px-4 py-2 message-bubble"
            :class="{ 'message-bubble-error': error }"
        >
            <slot name="header" />
            <slot />
            <slot name="footer" />
        </div>
    </div>
</template>

<style scoped>
    .message-container-outbound {
        justify-content: end;
    }

    .message-container-outbound .message-bubble {
        background: var(--secondary-color-selected);
        color: var(--secondary-color-hover);
    }

    .message-container-inbound {
        justify-content: start;
    }

    .message-container-inbound .message-bubble {
        background: var(--primary-transparent-3);
        color: var(--main-grey-text-color);
    }

    .message-container-inbound .message-bubble.message-bubble-error,
    .message-container-outbound .message-bubble.message-bubble-error {
        background: var(--danger-light);
        color: var(--danger-header-color);
    }

    .message-bubble :deep(ul),
    .message-bubble :deep(ol) {
        margin: 0.25rem 0;
        padding-left: 1.25rem;
    }
</style>
